import React, { useEffect, useState } from 'react';
import ViewOrderDetails from './orderDetails';
import CustomerDetails from './customerDetails';
import ProductQuestions from './productQuestions';
import { useSelector } from 'react-redux';
import api from '../../../api/api';
import { useDispatch } from 'react-redux';
import order, {
  emptyOrderData,
  getOrderById,
} from '../../../store/reducers/order';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toastSuccess } from '../../../common/UI/Toasts';
import {
  isUserAdmin,
  isUserDoctor,
  isUserPharmacist,
  validateFileExtensions,
  getFormDataFromObject,
} from '../../../utils/helpers';
import InternalNotes from '../ViewOrder/internalNotes';
import { Button } from 'react-bootstrap';
import imageCompression from 'browser-image-compression';
import ReactSelect from '../../../common/FormComponents/ReactSelect';
import { Form, Formik } from 'formik';

const ViewOrderProductPage = () => {
  const orderData = useSelector((state) => state.order.orderData);
  const { id, variantId } = useParams();
  const dispatch = useDispatch();
  const [thisOrderItem, setThisOrderItem] = useState();
  const [instruction, setInstruction] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const [orderImages, setOrderImages] = useState();
  const [uploadImageForm, setUploadImageForm] = useState(false);
  const [fullBodyPic, setFullBodyPic] = useState();
  const [photoId, setPhotoId] = useState();
  const [uploadPrescForm, setUploadPrescForm] = useState(false);
  const [prescriptionPhoto, setPrescriptionPhoto] = useState();
  const [buttonClicked, setButtonClicked] = useState(false);
  const [prevMedAns, setPrevMedAns] = useState()

  useEffect(() => {
    if (orderData) {
      let thisProductData = orderData?.orderItem.find(
        (el) => el.variant._id === variantId,
      );
      setThisOrderItem(thisProductData);
      setInstruction(thisProductData?.instruction || '');
      api.getOrderImages(orderData._id).then((res) => {
        setOrderImages(res.data.data[0]);
      });
    }
  }, [orderData]);

  const onChangeOfInstructionInput = (e) => {
    setInstruction(e.target.value);
  };

  const handleUploadBodyImage = async (imageData) => {
    const imageFile = imageData.answer;
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true
    }
    try {
      const compressedFile = await imageCompression(imageFile, options);
      api
      .uploadOrderImage(getFormDataFromObject({ photos: compressedFile }))
      .then((res) => {
        setFullBodyPic(res.data.data.photos[0]);
      })
      .catch((err) => {
        console.log(err);
      });
    } catch (error) {
      console.log(error);
    }
   
  };

  const handleUploadIDImage = async (imageData) => {
    const imageFile = imageData.answer;
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true
    }
    try {
      const compressedFile = await imageCompression(imageFile, options);
      api
      .uploadOrderImage(getFormDataFromObject({ photos: compressedFile }))
      .then((res) => {
        setPhotoId(res.data.data.photos[0]);
      })
      .catch((err) => {
        console.log(err);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleUploadPrescImage = (imageData) => {
    api
      .uploadOrderImage(getFormDataFromObject({ photos: imageData.answer }))
      .then((res) => {
        setPrescriptionPhoto(res.data.data.photos[0]);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const submitPrescImage = () => {
    let payload = { prescriptionPhoto: prescriptionPhoto };

    setButtonClicked(true);
    api
      .submitPrescImage(orderData._id, payload)
      .then((res) => {
        if (res.data.message == 'Image uploded successfully') {
          navigate(0);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const submitOrderImages = () => {
    let payload = {};

    if (fullBodyPic != null && photoId != null) {
      payload = {
        userPicture: fullBodyPic,
        userIdPicture: photoId,
      };
    } else if (fullBodyPic != null && photoId == null) {
      payload = {
        userPicture: fullBodyPic,
      };
    } else if (fullBodyPic == null && photoId != null) {
      payload = {
        userIdPicture: photoId,
      };
    }
    setButtonClicked(true);
    api
      .submitOrderImage(orderData._id, payload)
      .then((res) => {
        if (res.data.message == 'Image uploded successfully') {
          navigate(0);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const saveInstructions = () => {
    const payload = {
      instruction: instruction,
    };

    api
      .setInstructionForProductLabel(thisOrderItem?._id, payload)
      .then((res) => {
        toastSuccess('Added Instruction Successfully');
        dispatch(getOrderById(id));
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  const prevMedOptions = [
    { label: 'No i have never taken any GLP-1 before (I need to start on the first dose)', value: 'No i have never taken any GLP-1 before (I need to start on the first dose)' },
    { label: 'Semaglutide 0.25mg', value: 'Semaglutide 0.25mg' },
    { label: 'Semaglutide 0.5mg', value: 'Semaglutide 0.5mg' },
    { label: 'Semaglutide 1mg', value: 'Semaglutide 1mg' },
    { label: 'Semaglutide 1.7mg', value: 'Semaglutide 1.7mg' },
    { label: 'Semaglutide 2.4mg', value: 'Semaglutide 2.4mg' },
    { label: 'Tirzepatide 2.5mg', value: 'Tirzepatide 2.5mg' },
    { label: 'Tirzepatide 5mg', value: 'Tirzepatide 5mg' },
    { label: 'Tirzepatide 7.5mg', value: 'Tirzepatide 7.5mg' },
    { label: 'Tirzepatide 10mg', value: 'Tirzepatide 10mg' },
    { label: 'Tirzepatide 12.5mg', value: 'Tirzepatide 12.5mg' },
    { label: 'Tirzepatide 15mg', value: 'Tirzepatide 15mg' },
  ]

  const handleSubmit = () => {
    const payload = {answer: prevMedAns.value}
    api
      .changePrevMedAns(thisOrderItem?._id, payload)
      .then((res) => {
        navigate(0)
      })
      .catch((err) => {
        console.log('err', err);
      });
  }

  return (
    <>
      {!uploadImageForm && !uploadPrescForm && (
        <>
          <div className="row">
            <div className="col-md-12">
              <ol className="breadcrumb">
                <li>
                  <p
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      dispatch(emptyOrderData());
                      navigate(
                        location.state?.allOrdersPath
                          ? location.state?.allOrdersPath
                          : -2,
                        {
                          state: {
                            ...location.state,
                          },
                        },
                      );
                    }}
                    title="Product Management"
                  >
                    All Orders
                  </p>
                </li>
                <li>
                  <p
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      navigate(`/vieworder/${id}`);
                    }}
                    title="Product Management"
                  >
                    View Order
                  </p>
                </li>
                <li>View Order Product</li>
              </ol>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 col-xl-12 col-xxl-6 mb-3">
              <ViewOrderDetails key={orderData?._id} orderData={orderData} />
            </div>
            <div className="col-md-12 col-xl-12 col-xxl-6 mb-3">
              <CustomerDetails key={orderData?._id} orderData={orderData} />
            </div>
          </div>
          {(orderImages?.userPicture || orderImages?.userIdPicture) && (
            <div className="box_main">
              <div className="header_top">
                <h3>Full Body Picture & Photo Id</h3>
              </div>
              <div className="row order-images-section">
                {orderImages?.userPicture?.isdeleted ? (
                  <p>User Image was uploaded</p>
                ) : (
                  <>
                    {orderImages?.userPicture?.location ? (
                      <img
                        src={orderImages?.userPicture?.location}
                        alt=""
                        style={{
                          borderRadius: '16px',
                          width: '300px',
                          height: '150px',
                          objectFit: 'contain',
                        }}
                      />
                    ) : (
                      <></>
                    )}
                  </>
                )}
                {orderImages?.userIdPicture?.isdeleted ? (
                  <p>User ID was uploaded</p>
                ) : (
                  <>
                    {' '}
                    {orderImages?.userIdPicture?.location ? (
                      <img
                        src={orderImages?.userIdPicture?.location}
                        alt=""
                        style={{
                          borderRadius: '16px',
                          width: '300px',
                          height: '150px',
                          objectFit: 'contain',
                        }}
                      />
                    ) : (
                      <></>
                    )}
                  </>
                )}
              </div>
            </div>
          )}
          <button
            className={`btn btn-primary border-radius-16 fs-16 shadow-none shadow-focus-none my-1`}
            onClick={() => setUploadImageForm(true)}
          >
            Upload ID or full body image
          </button>
          <button
            className={`btn btn-primary border-radius-16 fs-16 shadow-none shadow-focus-none my-1 mx-4`}
            onClick={() => setUploadPrescForm(true)}
          >
            Upload Prescription image
          </button>
          {isUserAdmin() && (
            <>
              <div className="input-group">
                <Formik
                  onSubmit={(values) => {
                    handleSubmit(values);
                  }}
                >
                  {(formik) => {
                  return (
                    <>
                      <div className="d-flex col-xl-4 col-md-6 col-lg-6 form-group ">
                        <div className="input-group">
                          <ReactSelect
                            label="Change Previous Medication Answer"
                            labelClassname="form-label"
                            name="prev_med_ans"
                            className="form-select"
                            options={prevMedOptions}
                            height={'45px'}
                            containerWidth="100%"
                            wrappedStyles={{ width: '100%' }}
                            onChange={(value) => setPrevMedAns(value)}
                          />
                        </div>
                        <button
                          type="submit"
                          className="btn btn-success mt-5 mx-4"
                          onClick={() => handleSubmit()}
                        >
                          Submit
                        </button>
                      </div>
                    </>
                  )}}
                </Formik>
              </div>
            </>
          )}
          {thisOrderItem?.product?.type === 'medication' ? (
            <div className="row">
              <div className="col-md-12 mb-3">
                <div
                  className="header_top "
                  style={{ justifyContent: 'space-between' }}
                >
                  <h3>Add Instructions</h3>
                </div>

                <div className="d-flex">
                  <div
                    style={{
                      width: '40%',
                    }}
                  >
                    <textarea
                      disabled={isUserPharmacist()}
                      className="mt-4 form-control form-textarea"
                      rows="3"
                      value={instruction}
                      onChange={(e) => onChangeOfInstructionInput(e)}
                      placeholder="Write the instructions here..."
                      style={{ width: '100%', borderRadius: '0.5rem' }}
                    />
                    {instruction != '' &&
                    (!thisOrderItem.instruction ||
                      thisOrderItem.instruction != instruction) ? (
                      <span className="text-danger">
                        {thisOrderItem.instruction &&
                        thisOrderItem.instruction != instruction
                          ? `You have updated the instruction but haven't saved it.`
                          : `Instruction is not saved yet.`}
                      </span>
                    ) : null}
                  </div>
                  <div className="mt-4 ms-3">
                    {isUserDoctor() || isUserAdmin() ? (
                      <button
                        className="btn btn-primary mt-3"
                        onClick={saveInstructions}
                        disabled={!instruction || instruction == ''}
                      >
                        Save
                      </button>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <div className="box_main">
                  <div className="middle_main">
                    <InternalNotes />
                  </div>
                </div>
              </div>
              {(isUserDoctor() || isUserAdmin()) && (
                <div className="col-md-12">
                  <ProductQuestions
                    OrderItem={thisOrderItem}
                    orderStatus={orderData.current_order_status}
                  />
                </div>
              )}
            </div>
          ) : null}
        </>
      )}
      {uploadImageForm && (
        <>
          <div
            className="
           "
          >
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="box_main">
                    <Button
                      type="button"
                      variant="sky"
                      className="my-2 me-2"
                      onClick={() => setUploadImageForm(false)}
                    >
                      Back
                    </Button>
                    <div className="d-flex">
                      <label
                        className="p-2 text-center mt-2 mx-2 d-flex align-items-center justify-content-center"
                        style={{
                          borderRadius: '32px',
                          height: '52px',
                          border: '1px solid #ccc',
                          display: 'inline-block',
                          padding: ' 10px 22px',
                          cursor: 'pointer',
                          fontSize: '15px',
                        }}
                      >
                        {fullBodyPic ? (
                          <span className={``} onClick={() => {}}>
                            {fullBodyPic.originalname}
                          </span>
                        ) : (
                          'Upload your Full body Picture'
                        )}
                        <input
                          type="file"
                          accept="image/png, image/svg, image/jpeg, image/jpg, image/PNG, image/SVG, image/JPEG, image/JPG, image/webp, image/heic"
                          style={{ width: '300px', display: 'none' }}
                          onChange={(e) => {
                            if (validateFileExtensions(e.target.files[0])) {
                              handleUploadBodyImage({
                                answer: e.target.files[0],
                                prevUrl: URL.createObjectURL(e.target.files[0]),
                              });
                            }
                          }}
                        />
                      </label>

                      <label
                        className="p-2 text-center mt-2 mx-2 d-flex align-items-center justify-content-center"
                        style={{
                          borderRadius: '32px',
                          height: '52px',
                          border: '1px solid #ccc',
                          display: 'inline-block',
                          padding: ' 10px 22px',
                          cursor: 'pointer',
                          fontSize: '15px',
                        }}
                      >
                        {photoId ? (
                          <span className={``} onClick={() => {}}>
                            {photoId.originalname}
                          </span>
                        ) : (
                          'Upload a photo ID'
                        )}
                        <input
                          type="file"
                          accept="image/png, image/svg, image/jpeg, image/jpg, image/PNG, image/SVG, image/JPEG, image/JPG, image/webp, image/heic"
                          style={{ width: '300px', display: 'none' }}
                          onChange={(e) => {
                            if (validateFileExtensions(e.target.files[0])) {
                              handleUploadIDImage({
                                answer: e.target.files[0],
                                prevUrl: URL.createObjectURL(e.target.files[0]),
                              });
                            }
                          }}
                        />
                      </label>
                    </div>
                    <div>
                      <button
                        onClick={() => {
                          submitOrderImages();
                        }}
                        className={`btn btn-primary border-radius-24 fs-16 shadow-none shadow-focus-none my-1`}
                      >
                        {buttonClicked ? 'Loading...' : 'Submit'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {uploadPrescForm && (
        <>
          <div
            className="
           "
          >
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="box_main">
                    <Button
                      type="button"
                      variant="sky"
                      className="my-2 me-2"
                      onClick={() => setUploadPrescForm(false)}
                    >
                      Back
                    </Button>
                    <div className="d-flex">
                      <label
                        className="p-2 text-center mt-2 mx-2 d-flex align-items-center justify-content-center"
                        style={{
                          borderRadius: '32px',
                          height: '52px',
                          border: '1px solid #ccc',
                          display: 'inline-block',
                          padding: ' 10px 22px',
                          cursor: 'pointer',
                          fontSize: '15px',
                        }}
                      >
                        {prescriptionPhoto ? (
                          <span className={``} onClick={() => {}}>
                            {prescriptionPhoto.originalname}
                          </span>
                        ) : (
                          'Upload Prescription Picture'
                        )}
                        <input
                          type="file"
                          accept="image/png, image/svg, image/jpeg, image/jpg, image/PNG, image/SVG, image/JPEG, image/JPG, image/webp, image/heic"
                          style={{ width: '300px', display: 'none' }}
                          onChange={(e) => {
                            if (validateFileExtensions(e.target.files[0])) {
                              handleUploadPrescImage({
                                answer: e.target.files[0],
                                prevUrl: URL.createObjectURL(e.target.files[0]),
                              });
                            }
                          }}
                        />
                      </label>
                    </div>
                    <div>
                      <button
                        onClick={() => {
                          submitPrescImage();
                        }}
                        className={`btn btn-primary border-radius-24 fs-16 shadow-none shadow-focus-none my-1`}
                      >
                        {buttonClicked ? 'Loading...' : 'Submit'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ViewOrderProductPage;
